import React, { Component } from 'react';

import { Button, Table, Popconfirm, Modal } from 'antd';

import format from '@common/utils/formatters/_';

import Create from '@accreditamento/forms/completeRequest/efficacia/LivelloAbbandono';

import EfficaciaServices from '@accreditamento/services/Efficacia';




const columns = (component) => {
  return [
      {
        title: 'Anno',
        dataIndex: 'anno',
        key: 'anno',
        render: (text, record) => (<div style={{width: 150}}>{record.anno}</div>)
      }, {
        title: 'Macrotipologia',
        dataIndex: 'id_tipo_accreditamento',
        key: 'id_tipo_accreditamento',
        render: (text, record) => (<div style={{width: 150}}>{format.replaceStub(record.id_tipo_accreditamento, 'tipo_accreditamento', component.props.GlobalStore)}</div>)
      },
      {
        title: 'Allievi iscritti',
        dataIndex: 'allievi_iscritti',
        key: 'allievi_iscritti',
        render: (text, record) => (<div style={{width: 150}}>{record.allievi_iscritti}</div>)
      },
      {
        title: 'Allievi iscritti al termine',
        dataIndex: 'allievi_al_termine',
        key: 'allievi_al_termine',
        render: (text, record) => (<div style={{width: 150}}>{record.allievi_al_termine}</div>)
      },
      {
        title: '%',
        dataIndex: 'calc',
        key: 'calc',
        render: (text, record) => (<div style={{width: 150}}>{(record.allievi_iscritti !== 0) ? parseInt(record.allievi_al_termine/record.allievi_iscritti * 100) : 0}</div>)
      },
      {
        title: 'Azioni',
        dataIndex: 'azione',
        key: 'azione',
        render: (text, record) => (
          <div style={{width: 120}}>
            {// non dobbiamo mostrare l'ultima
              record.id_tipo_accreditamento ?
            <Popconfirm disabled={component.props.readOnly} placement="leftTop" title="Sicuro di voler rimuovere questo elemento?"
            onConfirm={() => component.delete(record.id)} okText="Si" cancelText="No">
              <Button loading={component.state.deleting.indexOf(record.id) !== -1} className="m2w" size="small" shape="circle" icon="delete" />
            </Popconfirm>
            : null}
          </div>
        ),
      }
    ];
  }


class LivelloAbbandonoList extends Component {

  state = {
    loading: false,
    open_drawer: false,
    updating_model: {},
    deleting: [],
    uploading: [],
    deleting_child: [],
    removing_file: [],
    open_modal: false
  };



  componentDidMount() {
    this.setState({

    })
  }





  delete(id) {
    if(this.state.deleting.indexOf(id) === -1) {
      this.setState({deleting: [...this.state.deleting, id]}, ()=>{
         EfficaciaServices.deleteLivelloAbbandono( this.props.accreditamento.id, id, () => {
           this.setState({deleting: this.state.deleting.filter(e=>e !== id)});
           if(this.props.onDelete) this.props.onDelete(id);
         }, ()=>this.setState({deleting: this.state.deleting.filter(e=>e !== id)}))
      })

    }
  }

  getDataSource() {
    let datas = [...this.props.livello_abbandono];
    let last_col = {
      id_tipo_accreditamento: null,
      allievi_iscritti: 0,
      allievi_al_termine: 0
    }
    this.props.livello_abbandono.forEach( c => {
      last_col.allievi_iscritti += c.allievi_iscritti;
      last_col.allievi_al_termine += c.allievi_al_termine
    });

    datas.push(last_col);
    return datas;
  }

  render() {
    return (
      <div style={{marginTop: 32}}>
        <h4>LIVELLO DI ABBANDONO DELLE ATTIVITÀ FORMATIVE PRECEDENTEMENTE REALIZZATE IN REGIME DI CONVENZIONE CON LA REGIONE CAMPANIA</h4>
        <Button
          type="primary"
          icon="plus"
          className="bg-green"
          disabled={this.props.readOnly}
          onClick={()=>this.setState({open_modal: true})}>
          Aggiungi scheda
        </Button>
        <Modal
          title="Inserisci scheda"
          visible={this.state.open_modal}
          onCancel={() => {
            this.setState({ open_modal: false }); this.formRef.reset();
          }}
          width={window.innerWidth / 100 * 80}
          okButtonProps={{style: {display: 'none'}}}

        >
          <Create
            ref={inst => (this.formRef = inst)}
            accreditamento={this.props.accreditamento}
            GlobalStore={this.props.GlobalStore}
            tipo_accreditamento={this.props.tipo_accreditamento}
            onCreate={()=>{
              this.setState({open_modal: false})
              this.props.onCreate()
            }}
          />
        </Modal>

        <Table
        loading={this.props.loading_data || this.props.loading_livello_abbandono}
        columns={columns(this)}
        rowKey={(record)=>"corso_"+record.id}
        pagination={false}
        dataSource={this.getDataSource()} />
      </div>
    );
  }
}
export default LivelloAbbandonoList;